function getCookie(name) {
    let matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

let cookiecook = getCookie("cookiecook"),
    cookiewin = document.getElementsByClassName('cookie')[0];

const closeBtn = document.querySelector('.cookie__close-btn');

if (closeBtn) {
    closeBtn.onclick = () => {
        cookiewin.style.display = "none";
    }
}

if (cookiecook != "no") {
    cookiewin.classList.add("show");
    document.getElementById("cookie__close").addEventListener("click", function () {
        cookiewin.style.display = "none";
        let date = new Date;
        date.setDate(date.getDate() + 30);
        document.cookie = "cookiecook=no; path=/; expires=" + date.toUTCString();
    });
} else {
    if (cookiewin)
        cookiewin.style.display = "none";
}